module.exports = {
    mounted() {
      // eslint-disable-next-line
      $(this.$el).foundation();
    },
    destroyed() {
      // eslint-disable-next-line
      if ($(this.$el).foundation && $(this.$el).foundation.destroy) {
        $(this.$el).foundation.destroy();
      }
    },
  };